import React from "react";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { QrScanner } from "react-qrcode-scanner";
import { AuthContext } from "../../App";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { postUserProduct, findProduct } from "../../utils/api";
import "../../components/button/button.css";
import "./scan.css";
import Error from "../error/error";
import FoundItem from "../../components/foundItem/foundItem";
import { authentication } from "../../utils/config";

function Scan() {
  //get route and lineProfile
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);

  //control whether the modal should appear or be hidden
  const [showModal, setShowModal] = useState(false);
  //track sweeter alert (is alert show, camera should stop scanning)
  const [isAlert, setIsAlert] = useState(false);
  // variable when the newProduct is detected
  const [newProduct, setNewProduct] = useState({
    productCode: "",
    type: "",
    model: "",
  });
  const [inputData, setInputData] = useState(null);

  useEffect(() => {
    //vertify user account
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
    };
    auth();
  }, []);

  // function to control the modal close
  const handleModalClose = () => {
    setShowModal(false);
    console.log("close", showModal);
  };

  useEffect(() => {
    console.log(showModal, isAlert);
  }, [showModal, isAlert]);

  //funciton to control when something scanned by camera
  const handleScan = async (value) => {
    // if modal or sweet alert are showing, camera stop fetch any api and do nothing
    if (showModal || isAlert) {
      console.log("再忙", showModal, isAlert);
    } else {
      // handle something must has a sweet alter reponse

      setInputData(value);
      const response = await findProduct(lineProfile, value);
      let result;
      if (response.error) {
        setIsAlert(true);
        result = await Swal.fire({
          title: "系統錯誤",
          text: JSON.stringify(response.data),
          icon: "error",
        });
        if (result.isConfirmed) setIsAlert(false);
      } else if (response.data === "not found the product") {
        setIsAlert(true);
        result = await Swal.fire({
          title: "商品編號錯誤",
          text: "請重新輸入或連繫客服",
          icon: "error",
        });
        if (result.isConfirmed) setIsAlert(false);
      } else {
        // if everything goes well, update the newProduct, and it would be showed is modal
        setNewProduct((preData) => ({
          ...preData,
          productCode: response.data.code,
          type: response.data.typeModel.type,
          model: response.data.typeModel.model,
        }));
        // modal must open
        setShowModal(true);
      }
    }
  };

  //when scanner is malfuncitonal
  const handleError = async (error) => {
    setIsAlert(true);
    console.log({ error });
    const result = await Swal.fire({
      title: "感應錯誤",
      text: "請檢查相機設備是否運作正常",
      icon: "error",
    });
    if (result.isConfirmed) {
      setIsAlert(false);
    }
  };

  // after information showing on modal , user press button to add this product into their name, then excute following funiton
  const handleModalSubmit = async () => {
    // call api to make user have this product
    const response = await postUserProduct(lineProfile, inputData);
    setIsAlert(true);
    let result;

    if (response.error) {
      result = await Swal.fire({
        title: "系統錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
    } else if (response.data === "not found the user") {
      result = await Swal.fire({
        title: "帳號不存在",
        text: "請註冊帳號",
        icon: "error",
      });
    } else if (response.data === "not found the product") {
      result = await Swal.fire({
        title: "商品不存在",
        text: "請重新輸入或掃描商品編號",
        icon: "error",
      });
    } else if (
      response.data === "have already registered the product with approvement"
    ) {
      result = await Swal.fire({
        title: "您已登錄此產品",
        icon: "warning",
      });
    } else {
      if (
        response.data.approvement === false ||
        response.data ===
          "have already registered the product without approvement"
      ) {
        result = await Swal.fire({
          title: "此產品已被登入",
          text: "請聯繫客服",
          icon: "question",
        });
      } else {
        result = await Swal.fire({
          title: "商品已加入",
          icon: "success",
        });
      }
    }
    if (result.isConfirmed) setIsAlert(false);
  };

  return (
    <div
      style={{
        backgroundColor: "#E4F4F3",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ flex: "1", padding: "50px" }}>
        {!isAlert && !showModal && (
          <QrScanner
            aspectRatio="3:4"
            style={{ height: "80%", transform: "scaleX(-1)", margin: "0 auto" }}
            onScan={handleScan}
            onError={handleError}
          />
        )}
      </div>
      <div style={{ marginTop: "auto", marginBottom: "16px" }}>
        <div className="text-center">
          <p className="fs-5" style={{ color: "#999C9C" }}>
            <u
              onClick={() => {
                navigate("/qrcodeplace");
              }}
            >
              <b>機器號碼位置</b>
            </u>
          </p>
          <Button
            className="mt-2 w-75 btn-custom-green "
            onClick={() => {
              navigate("/handadding");
            }}
          >
            查看已加入商品
          </Button>
        </div>
        <div
          className="text-center m-3 fs-5"
          style={{ color: "#42A6A1" }}
          onClick={() => {
            if (window.history.length <= 1) navigate("/main");
            else navigate(-1);
          }}
        >
          <b>返回</b>
        </div>
      </div>
      {showModal && (
        <FoundItem
          handleClose={handleModalClose}
          productCode={newProduct.productCode}
          type={newProduct.type}
          model={newProduct.model}
          api={handleModalSubmit}
        />
      )}
    </div>
  );
}

export default Scan;
